import { request as __request } from "../core/request.js";
export class ZarzDzanieSkrytkamiService {
    /**
     * Open parcel locker compartments
     * Metoda służy do otwarcia konkretnych skrytek paczkomatu
     * @returns BaseResponse Serwer przyjął żądanie, operacja zakończona powodzeniem
     * @throws ApiError
     */
    static async openParcelLocker({ requestBody, }) {
        const result = await __request({
            method: 'POST',
            path: `/api/apm/compartments`,
            body: requestBody,
            errors: {
                400: `Serwer nie mógł zrozumieć żądania z powodu niepoprawnej składni.`,
                404: `Nie znaleziono zasobu.`,
                500: `Wystąpił nieoczekiwany błąd po stronie serwera usługi.`,
            },
        });
        return result.body;
    }
}
//# sourceMappingURL=ZarzDzanieSkrytkamiService.js.map